// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZPU6tu {
  border: 1px solid #e8b985;
  background: #fff5e8;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  color: #63421e;
}
.tvOalv {
  display: block;
  width: 100%;
}
.QBs3ie {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin: 20px 0;
}
.A9eOIA {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.A9eOIA th,
.A9eOIA td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e2e5;
}
.JjVZ3x {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 0;
}
.JjVZ3x label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
}
.JjVZ3x select,
.JjVZ3x textarea,
.hxP4xa select {
  padding: 10px;
  border: 1px solid #c9cdd2;
  border-radius: 6px;
  background: white;
  color: #24272b;
}
.hxP4xa {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 320px;
  margin: 20px 0;
}
.KCrowF {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}
.MA_i9C {
  color: #b42332;
}
.XRaK3L {
  color: #156746;
}
.wf5NAo {
  display: inline-block;
  border-radius: 6px;
  padding: 4px 8px;
  background: #f5ecd8;
  color: #664411;
  font-size: 11px;
}
.Hx8kX4 p {
  font-size: 11px;
  color: #595e65;
}
.blH3P5 {
  text-align: left;
  width: 100%;
  border: 1px solid #e0e2e5;
  border-radius: 8px;
  padding: 12px;
  margin-top: 10px;
  background: white;
  color: #24272b;
}
.blH3P5:hover {
  border-color: #c94f00;
}
.blH3P5 strong,
.blH3P5 span {
  display: block;
}
.blH3P5 span {
  margin-top: 4px;
  font-size: 11px;
  color: #595e65;
}
.mvtY3_ {
  border: 1px solid #e0e2e5;
  padding: 14px;
  border-radius: 8px;
  margin: 16px 0;
  font-size: 13px;
}
.PU5Thg {
  position: fixed;
  right: 24px;
  bottom: 24px;
  border: 0;
  border-radius: 8px;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #c94f00, #713db8);
  color: white;
  box-shadow: 0 4px 16px #0003;
  font-weight: 700;
}
.bg7Z49 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}
.RX2qsQ {
  border: 1px solid #e0e2e5;
  border-radius: 12px;
  padding: 16px;
  background: white;
}
.RX2qsQ[data-author='user'] {
  margin-left: 20%;
  background: #f0f1f3;
}
.WNTnHo {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}
@media (max-width: 700px) {
  .WNTnHo {
    grid-template-columns: 1fr;
  }
  .QBs3ie {
    flex-wrap: wrap;
  }
}

.jpqiMs {
  border: 1px solid #e0c5a8;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 0;
  box-shadow: 0 2px 4px #0000001f;
  border-color: #fde68a;
  background: #fffbeb;
}
.jpqiMs[data-severity='insight'] {
  border-color: #ddd6fe;
  background: #f5f3ff;
}
.jpqiMs[data-severity='critical'] {
  border-color: #fecaca;
  background: #fef2f2;
}
.uTdsPJ {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.uTdsPJ svg {
  flex-shrink: 0;
}
.jpqiMs h3 {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 600;
  line-height: 17.5px;
  margin: 0;
}
.jpqiMs p {
  color: #595e65;
  margin: 4px 0 0;
  padding-left: 28px;
  font-size: 12px;
  line-height: 16.5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.uTdsPJ button {
  border: 0;
  padding: 0;
  background: transparent;
  color: #d64000;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.z5vBoU {
  padding: 2px 6px;
  border-radius: 4px;
  background: #fef3c7;
  color: #b45309;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}
[data-severity='insight'] .z5vBoU {
  background: #ede9fe;
  color: #6d28d9;
}
[data-severity='critical'] .z5vBoU {
  background: #fee2e2;
  color: #b91c1c;
}
.QBs3ie button,
.KCrowF button {
  min-height: 36px;
  font-size: 13px;
  padding: 8px 16px;
  border-radius: 4px;
}
.Lu3Xjc {
  overflow: auto;
  background: white;
  border: 1px solid #e0e2e5;
  border-radius: 8px;
  box-shadow: 0 2px 4px #0000001f;
}
.A9eOIA th {
  background: #f6f7f8;
  text-align: left;
  color: #595e65;
  font-weight: 500;
  font-size: 12px;
}
.Hx8kX4 header {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
}
.Dz9YoA {
  padding: 24px 24px 0;
}
.rcWOGo {
  margin-top: 8px;
  font-size: 14px;
  color: #70747a;
  line-height: 20px;
}
.XOjF2T {
  overflow-y: auto;
  padding: 16px 24px 24px;
  height: auto;
  flex: 1;
}
.oO3U7E {
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 16px 12px;
}
.oO3U7E > :nth-child(1),
.oO3U7E > :nth-child(2),
.oO3U7E > :nth-child(8) {
  grid-column: 1 / -1;
}
.oO3U7E > :nth-child(7) {
  grid-column: 1 / -1;
  max-width: 190px;
}
._O4GQN {
  font-size: 14px;
  font-weight: 600;
  color: #d64000;
  margin: 24px 0 16px;
  padding: 8px 0 12px;
  border-bottom: 2px solid #d64000;
  width: fit-content;
}
.JkHgET {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  align-items: start;
}
@media (max-width: 1100px) {
  .JkHgET {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 700px) {
  .JkHgET {
    grid-template-columns: 1fr;
  }
}
.Hx8kX4 {
  border: 1px solid #e0e2e5;
  padding: 12px;
  border-radius: 8px;
  background: white;
  border-color: #d9d9d9;
  box-shadow: 0 2px 4px #0000001f;
}
.Hx8kX4 .wf5NAo {
  font-size: 10px;
  border-radius: 12px;
  padding: 4px 8px;
  background: #fef3c7;
  color: #92400e;
}
.Hx8kX4[data-status='received'] .wf5NAo {
  background: #dbeafe;
  color: #1d4ed8;
}
.Hx8kX4[data-status='analyzing'] .wf5NAo {
  background: #ede9fe;
  color: #6d28d9;
}
.Hx8kX4[data-status='payroll'] .wf5NAo {
  background: #d1fae5;
  color: #047857;
}
.Hx8kX4[data-status='returned'] .wf5NAo {
  background: #fee2e2;
  color: #b91c1c;
}
.Hx8kX4 > p {
  margin: 8px 0 0;
  line-height: 16.5px;
}
.Hx8kX4 .blH3P5 {
  font-size: 13px;
  border-radius: 4px;
  padding: 10px;
}
.Hx8kX4 .blH3P5 strong {
  font-weight: 500;
}

.GtexiZ {
  margin: 0 0 24px;
}
.GtexiZ .hxP4xa {
  margin: 0;
  width: 320px;
}
.GtexiZ > button {
  position: absolute;
  right: 32px;
  top: 32px;
}
.wf5NAo[data-status] {
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  border-radius: 4px;
}
.wf5NAo[data-status='notInvited'] {
  background: #f1f2f3;
  color: #59636e;
}
.wf5NAo[data-status='invited'] {
  background: #fffbeb;
  color: #b45309;
}
.wf5NAo[data-status='active'] {
  background: #ecfdf5;
  color: #047857;
}
.u0BDMJ {
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: none;
  height: 100%;
  min-height: 0;
  gap: 0;
  position: relative;
}
.u0BDMJ > .QBs3ie {
  margin: 0;
  padding: 12px 24px;
  border-bottom: 1px solid #d9d9d9;
  background: white;
}
.sR7Q1Q {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  font-size: 11px;
  color: white;
  background: linear-gradient(90deg, #d64000, #7c3aed);
  border-radius: 12px;
}
.WYXIm3 {
  font-size: 10px;
  color: #70747a;
  text-align: center;
  padding: 8px;
}
.u0BDMJ h2 {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 30px;
  font-weight: 600;
  margin: 0 0 24px;
}
.u0BDMJ h2 svg {
  color: #d64000;
}
.u0BDMJ[data-initial='true'] h2 {
  order: 1;
  margin-top: auto;
}
.u0BDMJ[data-initial='true'] .GZlEqc {
  order: 2;
  margin: 0 auto;
}
.u0BDMJ[data-initial='true'] .bg7Z49 {
  order: 3;
  margin: 16px auto auto;
  max-width: 720px;
  padding: 0 24px 64px;
}
.u0BDMJ[data-initial='true'] > [aria-live] {
  display: none;
}
.GZlEqc .KCrowF {
  margin-top: 8px;
}
.u0BDMJ > [aria-live] {
  flex: 1;
  overflow-y: auto;
  width: min(720px, 100%);
  margin: 0 auto;
  padding: 24px;
}
.bg7Z49 button {
  border: 1px solid #c9cdd2;
  background: white;
  color: #454a51;
  font-size: 12px;
  border-radius: 4px;
  padding: 6px 12px;
}
@media (max-width: 700px) {
  .GtexiZ > button {
    position: static;
  }
  .oO3U7E {
    grid-template-columns: 1fr;
  }
  .oO3U7E > * {
    grid-column: 1 !important;
  }
}

.sX_Bc2 {
  width: 512px;
  max-width: 100vw;
  background: #f7f8fa;
  box-shadow: -4px 0 20px #0002;
}
.tvOalv input,
.tvOalv select,
.tvOalv textarea {
  border: 1px solid #e0e5eb;
  border-radius: 12px;
  background: #f7f8fa;
  font-size: 14px;
  padding: 8px 12px;
  min-height: 38px;
}
.tvOalv .KCrowF button {
  border-radius: 12px;
  background: #ff6418;
  border-color: #ff6418;
}
.tvOalv .KCrowF button:first-child {
  background: transparent;
  border-color: #e0e5eb;
  color: #24272b;
}
.tvOalv .ZPU6tu {
  margin: 0;
  border: 0;
  padding: 0;
  background: transparent;
  font-size: 10px;
}
.tvOalv .JjVZ3x {
  padding: 12px 0 0;
  gap: 16px;
}
.tvOalv .KCrowF {
  margin-top: 20px;
}

.GZlEqc {
  width: min(720px, 100%);
  margin: auto auto 16px;
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  box-shadow: 0 2px 4px #0000001f;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
}
.GZlEqc input {
  flex: 1;
  min-width: 0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  padding: 10px 16px;
  background: #f8f9fc;
}
.GZlEqc button {
  height: 36px;
  width: 36px;
  flex-shrink: 0;
  border: 0;
  border-radius: 4px;
  color: white;
  background: linear-gradient(135deg, #d64000, #7c3aed);
  font-size: 22px;
}
.GZlEqc button:disabled {
  opacity: 0.4;
}
.ZPU6tu button {
  border: 0;
  background: transparent;
  color: inherit;
  text-decoration: underline;
}
.A9eOIA td button {
  min-height: 36px;
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 4px;
}

@media (max-width: 700px) {
  .uTdsPJ {
    flex-wrap: wrap;
    gap: 6px;
  }
  .uTdsPJ h3 {
    flex-basis: 100%;
    order: 2;
  }
  .uTdsPJ button {
    margin-left: auto;
  }
  .Lu3Xjc {
    max-width: 100%;
  }
}

.LnHaxH {
  border: 1px solid #ffc4a8;
  background: #fff0e9;
  padding: 12px 16px;
  border-radius: 8px;
  line-height: 21px;
  box-shadow: 0 2px 4px #0000001f;
  display: flex;
  gap: 12px;
  align-items: start;
}
.LnHaxH svg {
  margin-top: 3px;
  flex-shrink: 0;
  color: #b93600;
}
.lu3meT {
  width: 448px;
  max-width: 100%;
  padding: 10px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: white;
  font-size: 13px;
}
.X6ybV1 {
  display: flex;
  align-items: center;
  gap: 12px;
}
.kMHL7R {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;
  background: #fff0e9;
  color: #b93600;
  flex-shrink: 0;
}
.X6ybV1 strong {
  font-weight: 500;
}
.A9eOIA:has(.X6ybV1) th {
  text-transform: uppercase;
  font-size: 10px;
}
.A9eOIA:has(.X6ybV1) td:last-child,
.A9eOIA:has(.X6ybV1) th:last-child {
  text-align: right;
}
.A9eOIA:has(.X6ybV1) button {
  min-width: 108px;
}
.A9eOIA:has(.X6ybV1) button[data-variant='secondary'] {
  background: #f8f9fc;
  border-color: #d9d9d9;
  color: #24272b;
}

.e_sefa {
  position: relative;
  display: block;
  width: 448px;
  max-width: 100%;
}
.e_sefa > svg {
  position: absolute;
  left: 12px;
  top: 12px;
  color: #666;
}
.e_sefa input {
  padding-left: 36px;
}
.UZo0Fy th:first-child {
  width: 36%;
}
.UZo0Fy th:nth-child(2) {
  width: 17%;
}
.UZo0Fy th:nth-child(3) {
  width: 17%;
}
.UZo0Fy th:nth-child(4) {
  width: 15%;
}
.UZo0Fy td:not(:first-child) {
  color: #595e65;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Bpo/BpoDemo.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;AACA;;;EAGE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,OAAO;AACT;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,gDAAgD;EAClD;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,MAAM;EACN,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,cAAc;AAChB;AACA;EACE,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;;;EAGE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;AACA;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,QAAQ;EACV;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;AAChB","sourcesContent":[".notice {\n  border: 1px solid #e8b985;\n  background: #fff5e8;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #63421e;\n}\n.drawerBodyContent {\n  display: block;\n  width: 100%;\n}\n.toolbar {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  margin: 20px 0;\n}\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e2e5;\n}\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 0;\n}\n.form label {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-size: 13px;\n}\n.form select,\n.form textarea,\n.filter select {\n  padding: 10px;\n  border: 1px solid #c9cdd2;\n  border-radius: 6px;\n  background: white;\n  color: #24272b;\n}\n.filter {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-width: 320px;\n  margin: 20px 0;\n}\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 20px;\n}\n.error {\n  color: #b42332;\n}\n.success {\n  color: #156746;\n}\n.badge {\n  display: inline-block;\n  border-radius: 6px;\n  padding: 4px 8px;\n  background: #f5ecd8;\n  color: #664411;\n  font-size: 11px;\n}\n.column p {\n  font-size: 11px;\n  color: #595e65;\n}\n.card {\n  text-align: left;\n  width: 100%;\n  border: 1px solid #e0e2e5;\n  border-radius: 8px;\n  padding: 12px;\n  margin-top: 10px;\n  background: white;\n  color: #24272b;\n}\n.card:hover {\n  border-color: #c94f00;\n}\n.card strong,\n.card span {\n  display: block;\n}\n.card span {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #595e65;\n}\n.detail {\n  border: 1px solid #e0e2e5;\n  padding: 14px;\n  border-radius: 8px;\n  margin: 16px 0;\n  font-size: 13px;\n}\n.aiButton {\n  position: fixed;\n  right: 24px;\n  bottom: 24px;\n  border: 0;\n  border-radius: 8px;\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, #c94f00, #713db8);\n  color: white;\n  box-shadow: 0 4px 16px #0003;\n  font-weight: 700;\n}\n.suggestions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.message {\n  border: 1px solid #e0e2e5;\n  border-radius: 12px;\n  padding: 16px;\n  background: white;\n}\n.message[data-author='user'] {\n  margin-left: 20%;\n  background: #f0f1f3;\n}\n.insights {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-top: 16px;\n}\n@media (max-width: 700px) {\n  .insights {\n    grid-template-columns: 1fr;\n  }\n  .toolbar {\n    flex-wrap: wrap;\n  }\n}\n\n.insight {\n  border: 1px solid #e0c5a8;\n  border-radius: 8px;\n  padding: 8px 12px;\n  min-width: 0;\n  box-shadow: 0 2px 4px #0000001f;\n  border-color: #fde68a;\n  background: #fffbeb;\n}\n.insight[data-severity='insight'] {\n  border-color: #ddd6fe;\n  background: #f5f3ff;\n}\n.insight[data-severity='critical'] {\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n.insightHeading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n.insightHeading svg {\n  flex-shrink: 0;\n}\n.insight h3 {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 17.5px;\n  margin: 0;\n}\n.insight p {\n  color: #595e65;\n  margin: 4px 0 0;\n  padding-left: 28px;\n  font-size: 12px;\n  line-height: 16.5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.insightHeading button {\n  border: 0;\n  padding: 0;\n  background: transparent;\n  color: #d64000;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.severity {\n  padding: 2px 6px;\n  border-radius: 4px;\n  background: #fef3c7;\n  color: #b45309;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n[data-severity='insight'] .severity {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n[data-severity='critical'] .severity {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n.toolbar button,\n.footer button {\n  min-height: 36px;\n  font-size: 13px;\n  padding: 8px 16px;\n  border-radius: 4px;\n}\n.tableWrap {\n  overflow: auto;\n  background: white;\n  border: 1px solid #e0e2e5;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px #0000001f;\n}\n.table th {\n  background: #f6f7f8;\n  text-align: left;\n  color: #595e65;\n  font-weight: 500;\n  font-size: 12px;\n}\n.column header {\n  display: flex;\n  justify-content: space-between;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.drawerHeader {\n  padding: 24px 24px 0;\n}\n.drawerSubtitle {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #70747a;\n  line-height: 20px;\n}\n.drawerBody {\n  overflow-y: auto;\n  padding: 16px 24px 24px;\n  height: auto;\n  flex: 1;\n}\n.admissionForm {\n  display: grid;\n  grid-template-columns: 2fr 3fr;\n  gap: 16px 12px;\n}\n.admissionForm > :nth-child(1),\n.admissionForm > :nth-child(2),\n.admissionForm > :nth-child(8) {\n  grid-column: 1 / -1;\n}\n.admissionForm > :nth-child(7) {\n  grid-column: 1 / -1;\n  max-width: 190px;\n}\n.tabHeading {\n  font-size: 14px;\n  font-weight: 600;\n  color: #d64000;\n  margin: 24px 0 16px;\n  padding: 8px 0 12px;\n  border-bottom: 2px solid #d64000;\n  width: fit-content;\n}\n.board {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  align-items: start;\n}\n@media (max-width: 1100px) {\n  .board {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n@media (max-width: 700px) {\n  .board {\n    grid-template-columns: 1fr;\n  }\n}\n.column {\n  border: 1px solid #e0e2e5;\n  padding: 12px;\n  border-radius: 8px;\n  background: white;\n  border-color: #d9d9d9;\n  box-shadow: 0 2px 4px #0000001f;\n}\n.column .badge {\n  font-size: 10px;\n  border-radius: 12px;\n  padding: 4px 8px;\n  background: #fef3c7;\n  color: #92400e;\n}\n.column[data-status='received'] .badge {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n.column[data-status='analyzing'] .badge {\n  background: #ede9fe;\n  color: #6d28d9;\n}\n.column[data-status='payroll'] .badge {\n  background: #d1fae5;\n  color: #047857;\n}\n.column[data-status='returned'] .badge {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n.column > p {\n  margin: 8px 0 0;\n  line-height: 16.5px;\n}\n.column .card {\n  font-size: 13px;\n  border-radius: 4px;\n  padding: 10px;\n}\n.column .card strong {\n  font-weight: 500;\n}\n\n.admissionToolbar {\n  margin: 0 0 24px;\n}\n.admissionToolbar .filter {\n  margin: 0;\n  width: 320px;\n}\n.admissionToolbar > button {\n  position: absolute;\n  right: 32px;\n  top: 32px;\n}\n.badge[data-status] {\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: 700;\n  border-radius: 4px;\n}\n.badge[data-status='notInvited'] {\n  background: #f1f2f3;\n  color: #59636e;\n}\n.badge[data-status='invited'] {\n  background: #fffbeb;\n  color: #b45309;\n}\n.badge[data-status='active'] {\n  background: #ecfdf5;\n  color: #047857;\n}\n.agent {\n  display: flex;\n  flex-direction: column;\n  margin: auto;\n  max-width: none;\n  height: 100%;\n  min-height: 0;\n  gap: 0;\n  position: relative;\n}\n.agent > .toolbar {\n  margin: 0;\n  padding: 12px 24px;\n  border-bottom: 1px solid #d9d9d9;\n  background: white;\n}\n.aiBadge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  font-size: 11px;\n  color: white;\n  background: linear-gradient(90deg, #d64000, #7c3aed);\n  border-radius: 12px;\n}\n.aiDemo {\n  font-size: 10px;\n  color: #70747a;\n  text-align: center;\n  padding: 8px;\n}\n.agent h2 {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 30px;\n  font-weight: 600;\n  margin: 0 0 24px;\n}\n.agent h2 svg {\n  color: #d64000;\n}\n.agent[data-initial='true'] h2 {\n  order: 1;\n  margin-top: auto;\n}\n.agent[data-initial='true'] .agentInput {\n  order: 2;\n  margin: 0 auto;\n}\n.agent[data-initial='true'] .suggestions {\n  order: 3;\n  margin: 16px auto auto;\n  max-width: 720px;\n  padding: 0 24px 64px;\n}\n.agent[data-initial='true'] > [aria-live] {\n  display: none;\n}\n.agentInput .footer {\n  margin-top: 8px;\n}\n.agent > [aria-live] {\n  flex: 1;\n  overflow-y: auto;\n  width: min(720px, 100%);\n  margin: 0 auto;\n  padding: 24px;\n}\n.suggestions button {\n  border: 1px solid #c9cdd2;\n  background: white;\n  color: #454a51;\n  font-size: 12px;\n  border-radius: 4px;\n  padding: 6px 12px;\n}\n@media (max-width: 700px) {\n  .admissionToolbar > button {\n    position: static;\n  }\n  .admissionForm {\n    grid-template-columns: 1fr;\n  }\n  .admissionForm > * {\n    grid-column: 1 !important;\n  }\n}\n\n.drawer {\n  width: 512px;\n  max-width: 100vw;\n  background: #f7f8fa;\n  box-shadow: -4px 0 20px #0002;\n}\n.drawerBodyContent input,\n.drawerBodyContent select,\n.drawerBodyContent textarea {\n  border: 1px solid #e0e5eb;\n  border-radius: 12px;\n  background: #f7f8fa;\n  font-size: 14px;\n  padding: 8px 12px;\n  min-height: 38px;\n}\n.drawerBodyContent .footer button {\n  border-radius: 12px;\n  background: #ff6418;\n  border-color: #ff6418;\n}\n.drawerBodyContent .footer button:first-child {\n  background: transparent;\n  border-color: #e0e5eb;\n  color: #24272b;\n}\n.drawerBodyContent .notice {\n  margin: 0;\n  border: 0;\n  padding: 0;\n  background: transparent;\n  font-size: 10px;\n}\n.drawerBodyContent .form {\n  padding: 12px 0 0;\n  gap: 16px;\n}\n.drawerBodyContent .footer {\n  margin-top: 20px;\n}\n\n.agentInput {\n  width: min(720px, 100%);\n  margin: auto auto 16px;\n  background: white;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px #0000001f;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px;\n}\n.agentInput input {\n  flex: 1;\n  min-width: 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  font-size: 14px;\n  padding: 10px 16px;\n  background: #f8f9fc;\n}\n.agentInput button {\n  height: 36px;\n  width: 36px;\n  flex-shrink: 0;\n  border: 0;\n  border-radius: 4px;\n  color: white;\n  background: linear-gradient(135deg, #d64000, #7c3aed);\n  font-size: 22px;\n}\n.agentInput button:disabled {\n  opacity: 0.4;\n}\n.notice button {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-decoration: underline;\n}\n.table td button {\n  min-height: 36px;\n  padding: 8px 16px;\n  font-size: 13px;\n  border-radius: 4px;\n}\n\n@media (max-width: 700px) {\n  .insightHeading {\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n  .insightHeading h3 {\n    flex-basis: 100%;\n    order: 2;\n  }\n  .insightHeading button {\n    margin-left: auto;\n  }\n  .tableWrap {\n    max-width: 100%;\n  }\n}\n\n.accountingNotice {\n  border: 1px solid #ffc4a8;\n  background: #fff0e9;\n  padding: 12px 16px;\n  border-radius: 8px;\n  line-height: 21px;\n  box-shadow: 0 2px 4px #0000001f;\n  display: flex;\n  gap: 12px;\n  align-items: start;\n}\n.accountingNotice svg {\n  margin-top: 3px;\n  flex-shrink: 0;\n  color: #b93600;\n}\n.clientSearch {\n  width: 448px;\n  max-width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  background: white;\n  font-size: 13px;\n}\n.companyCell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.companyIcon {\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 4px;\n  background: #fff0e9;\n  color: #b93600;\n  flex-shrink: 0;\n}\n.companyCell strong {\n  font-weight: 500;\n}\n.table:has(.companyCell) th {\n  text-transform: uppercase;\n  font-size: 10px;\n}\n.table:has(.companyCell) td:last-child,\n.table:has(.companyCell) th:last-child {\n  text-align: right;\n}\n.table:has(.companyCell) button {\n  min-width: 108px;\n}\n.table:has(.companyCell) button[data-variant='secondary'] {\n  background: #f8f9fc;\n  border-color: #d9d9d9;\n  color: #24272b;\n}\n\n.searchWrap {\n  position: relative;\n  display: block;\n  width: 448px;\n  max-width: 100%;\n}\n.searchWrap > svg {\n  position: absolute;\n  left: 12px;\n  top: 12px;\n  color: #666;\n}\n.searchWrap input {\n  padding-left: 36px;\n}\n.inviteTable th:first-child {\n  width: 36%;\n}\n.inviteTable th:nth-child(2) {\n  width: 17%;\n}\n.inviteTable th:nth-child(3) {\n  width: 17%;\n}\n.inviteTable th:nth-child(4) {\n  width: 15%;\n}\n.inviteTable td:not(:first-child) {\n  color: #595e65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notice": `ZPU6tu`,
	"drawerBodyContent": `tvOalv`,
	"toolbar": `QBs3ie`,
	"table": `A9eOIA`,
	"form": `JjVZ3x`,
	"filter": `hxP4xa`,
	"footer": `KCrowF`,
	"error": `MA_i9C`,
	"success": `XRaK3L`,
	"badge": `wf5NAo`,
	"column": `Hx8kX4`,
	"card": `blH3P5`,
	"detail": `mvtY3_`,
	"aiButton": `PU5Thg`,
	"suggestions": `bg7Z49`,
	"message": `RX2qsQ`,
	"insights": `WNTnHo`,
	"insight": `jpqiMs`,
	"insightHeading": `uTdsPJ`,
	"severity": `z5vBoU`,
	"tableWrap": `Lu3Xjc`,
	"drawerHeader": `Dz9YoA`,
	"drawerSubtitle": `rcWOGo`,
	"drawerBody": `XOjF2T`,
	"admissionForm": `oO3U7E`,
	"tabHeading": `_O4GQN`,
	"board": `JkHgET`,
	"admissionToolbar": `GtexiZ`,
	"agent": `u0BDMJ`,
	"aiBadge": `sR7Q1Q`,
	"aiDemo": `WYXIm3`,
	"agentInput": `GZlEqc`,
	"drawer": `sX_Bc2`,
	"accountingNotice": `LnHaxH`,
	"clientSearch": `lu3meT`,
	"companyCell": `X6ybV1`,
	"companyIcon": `kMHL7R`,
	"searchWrap": `e_sefa`,
	"inviteTable": `UZo0Fy`
};
module.exports = ___CSS_LOADER_EXPORT___;
